import { render, staticRenderFns } from "./ReviewsCategoriesColorScaleTable.vue?vue&type=template&id=19049b7b&"
import script from "./ReviewsCategoriesColorScaleTable.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesColorScaleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports